document.addEventListener('DOMContentLoaded', function () {
  function getProductForm(productSection) {
    return (
      productSection.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function getSelectedVariantId(productSection) {
    const form = getProductForm(productSection);
    if (!form) return null;

    const checkedOptionRadio = form.querySelector('input[type="radio"]:checked[data-variant-id]');
    if (checkedOptionRadio && checkedOptionRadio.dataset.variantId) {
      return checkedOptionRadio.dataset.variantId;
    }

    const selectedOption = form.querySelector('select option:checked[data-variant-id]');
    if (selectedOption && selectedOption.dataset.variantId) {
      return selectedOption.dataset.variantId;
    }

    const variantSelect = form.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      return variantSelect.value;
    }

    const hiddenVariantInput = form.querySelector('input[name="id"][type="hidden"]');
    if (hiddenVariantInput && hiddenVariantInput.value) {
      return hiddenVariantInput.value;
    }

    return null;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function updateSetupListItem(el, value) {
    if (!el) return;

    if (value) {
      el.textContent = value;
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function updateSpecRow(specsSection, key, value) {
    if (!specsSection) return;

    const row = specsSection.querySelector(`[data-spec-row="${key}"]`);
    const cell = specsSection.querySelector(`[data-spec-${key}]`);

    if (!row || !cell) return;

    if (value) {
      cell.textContent = value;
      row.style.display = '';
    } else {
      cell.textContent = '';
      row.style.display = 'none';
    }
  }

  function updateProductSetup(productSection) {
    if (!productSection) return;

    const productId = productSection.id.replace('variant-clarity-setup-', '');
    const dataEl = document.getElementById(`variant-clarity-setup-data-${productId}`);
    const specsDataEl = document.getElementById(`rod-specs-data-${productId}`);
    const specsSection = document.getElementById(`rod-specs-${productId}`);

    if (!dataEl) return;

    let variantData;
    try {
      variantData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('Variant setup JSON parse failed');
      return;
    }

    const variantId = getSelectedVariantId(productSection);
    const key = String(variantId);

    if (!key || !variantData[key]) return;

    const data = variantData[key];

    const clarityEl = productSection.querySelector('[data-clarity]');
    const setupEl = productSection.querySelector('[data-setup]');
    const setupTitleEl = productSection.querySelector('[data-setup-title]');
    const baitEl = productSection.querySelector('[data-setup-bait]');
    const reelEl = productSection.querySelector('[data-setup-reel]');
    const lineEl = productSection.querySelector('[data-setup-line]');
    const idealWeightWrapEl = productSection.querySelector('[data-setup-ideal-weight-wrap]');
    const idealWeightEl = productSection.querySelector('[data-setup-ideal-weight]');
    const philosophyEl = productSection.querySelector('[data-setup-philosophy]');
    const baitsWrapEl = productSection.querySelector('[data-setup-baits-wrap]');
    const baitsEl = productSection.querySelector('[data-setup-baits]');

    if (clarityEl) {
      if (data.clarity) {
        clarityEl.textContent = data.clarity;
        clarityEl.style.display = '';
      } else {
        clarityEl.textContent = '';
        clarityEl.style.display = 'none';
      }
    }

    if (setupTitleEl) {
      setupTitleEl.textContent = data.label
        ? `Recommended Setup for ${data.label}`
        : 'Recommended Setup';
    }

    const hasSetup = data.bait || data.reel || data.line || data.ideal_weight || data.baits;

    if (setupEl) {
      setupEl.style.display = hasSetup ? '' : 'none';
    }

    updateSetupListItem(baitEl, data.bait);
    updateSetupListItem(reelEl, data.reel);
    updateSetupListItem(lineEl, data.line);

    if (idealWeightWrapEl && idealWeightEl) {
      if (data.ideal_weight) {
        idealWeightEl.textContent = data.ideal_weight;
        idealWeightWrapEl.style.display = '';
      } else {
        idealWeightEl.textContent = '';
        idealWeightWrapEl.style.display = 'none';
      }
    }

    if (philosophyEl) {
      philosophyEl.style.display = data.ideal_weight ? '' : 'none';
    }

    if (baitsWrapEl && baitsEl) {
      if (data.baits) {
        const baitItems = data.baits
          .split('\n')
          .map(function (item) {
            return item.trim();
          })
          .filter(Boolean)
          .slice(0, 3)
          .map(function (item) {
            return `<li>${escapeHtml(item)}</li>`;
          })
          .join('');

        baitsEl.innerHTML = baitItems;
        baitsWrapEl.style.display = '';
      } else {
        baitsEl.innerHTML = '';
        baitsWrapEl.style.display = 'none';
      }
    }

    if (specsDataEl && specsSection) {
      let specsData;
      try {
        specsData = JSON.parse(specsDataEl.textContent);
      } catch (e) {
        console.warn('Specs JSON parse failed');
        return;
      }

      if (!specsData[key]) return;

      const s = specsData[key];

      updateSpecRow(specsSection, 'length', s.length);
      updateSpecRow(specsSection, 'applications', s.applications);
      updateSpecRow(specsSection, 'power', s.power);
      updateSpecRow(specsSection, 'action', s.action);
      updateSpecRow(specsSection, 'lure', s.lure);
      updateSpecRow(specsSection, 'line', s.line);
      updateSpecRow(specsSection, 'blank-color', s.blank_color);
      updateSpecRow(specsSection, 'pieces', s.pieces);
      updateSpecRow(specsSection, 'handle', s.handle);

      const specNoteEl = specsSection.querySelector('[data-spec-note]');
      if (specNoteEl) {
        specNoteEl.style.display = s.ideal_weight ? '' : 'none';
      }
    }
  }

  function initProductSetup() {
    const productSections = document.querySelectorAll('[id^="variant-clarity-setup-"]');
    if (!productSections.length) return;

    productSections.forEach(function (productSection) {
      updateProductSetup(productSection);

      const form = getProductForm(productSection);
      if (!form) return;

      form.addEventListener('change', function () {
        setTimeout(function () {
          updateProductSetup(productSection);
        }, 0);
      });

      form.addEventListener('input', function () {
        setTimeout(function () {
          updateProductSetup(productSection);
        }, 0);
      });
    });
  }

  initProductSetup();
});